/*
 *   File : SummaryCard.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React from "react";
import Icon from "../icons";
import {  useNavigate } from "react-router-dom";

export default function SummaryCard(props) {
  const navigate = useNavigate();
  const handleNavigation = () => {
    if (props.nav && props.nav.trim() !== "") navigate(props.nav?.toLowerCase());
  };
  return (
    <div
      onClick={handleNavigation}
      className={`d-flex flex-column e-bg-floral-white e-py-20px px-3  e-border-1px-blond rounded-4 ${props.extraClasses} ${
        props.nav ? "e-cursor-pointer" : ""
      }`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="e-font-12 e-font-weight-500 text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
          {props.title}
        </h4>
        {props.icon !== false && (
          <Icon icon={props.icon} color="black" size="20px" />
        )}
      </div>
      <div>
        <p className=" fs-3 e-font-22 e-font-weight-700 e-secondary-font-Inter p-0 m-0">
          {props.content}
        </p>
      </div>
    </div>
  );
}
